<template>
    <div class="full-width">
        <el-scrollbar>
            <record5YearList :yearList="yearList" :currYear="currYear" @clickYear="selectYear" />

            <hr class="my-hr">

            <record5List :record5List="recordList" @clickImg="clickImgFunc" />

            <div class="img-view" v-show="null != previewImgUrl">
                <div style="position: absolute; top: 2px; right: 10px">
                    <el-button size="small" type="danger" @click="previewImgUrl = null" tkey="關閉">{{i18n.tkey("lang_close")}}</el-button>
                </div>

                <img :src="previewImgUrl" style="width: 100%; height: 100%; object-fit: scale-down">
            </div>
        </el-scrollbar>
    </div>
</template>

<script setup>
    import record5YearList from "@/components/shopopee/record5/record5YearList"
    import record5List from "@/components/shopopee/record5/record5List"
    import {inject, onMounted, ref} from "vue";
    import record5Api from "@/request/record5Api";
    import myUtil from "@/util/util";

    const props = defineProps(["code"])

    const i18n = inject("i18n")

    const yearList = ref([])
    const recordList = ref([])
    const currYear = ref(null)
    const previewImgUrl = ref(null)

    function getYears() {
        const request = record5Api.queryYears
        const params = request.getParams()

        params.companycode = props.code

        request.send(params, (res) => {
            if (res.code == 200 && null != res.detail){
                yearList.value = res.detail
            }
        })

    }

    function getRecord(){
        const request = record5Api.queryMemberWorkAndRecordByPage
        const params = request.getParams()

        params.companycode = props.code
        params.pageSize = 100

        if (null != currYear.value){
            params.addinfo2 = currYear.value + "/01/01"
            params.addinfo3 = currYear.value + "/12/31"
        }

        request.send(params, fillRecord)

    }

    function fillRecord(res){
        recordList.value = []
        if (res.code == 200){
            if (myUtil.isNotEmpty(res.detail)){
                recordList.value = res.detail.additionalrecord5FileModelList.list
            }
        }else{
            myUtil.alertError(res.msg)
        }
    }

    function selectYear(year){
        if (year == currYear.value){
            currYear.value = null
        }else{
            currYear.value = year
        }

        getRecord()
    }

    function clickImgFunc(url){
        previewImgUrl.value = url
    }

    onMounted(() => {
        getYears()
        getRecord()
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
        padding-left: 2px;
        padding-right: 2px;
        box-sizing: border-box;
        overflow-y: auto;
        /*padding-top: 5px;*/
        position: relative;
    }

    .my-hr {
        margin-top: 10px;
        margin-bottom: 20px;
        border: 0;
        border-top: 1px solid #eee;
    }

    .img-view {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        padding: 20px;
        box-sizing: border-box;
        background-color: #a6a6a6e8;
    }
</style>